import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer';
import { Reader } from './qr-reader';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import SubEventList from './sub-event-list';
import { useEvents } from '@/api/useEvents';
import { useSettingsStore } from '@/stores/settingsStore';
import { Spinner } from '@/components/ui/spinner';
import { ChevronsUpDown, DoorOpen } from 'lucide-react';
import { getLabelValue } from '@/utils/getLabelValue';
import { cn } from '@/utils';

export function Scan() {
  const currentEventId = useSettingsStore(state => state.eventId);
  const breakoutId = useSettingsStore(state => state.breakoutId);

  const { data: events = [], isLoading: isLoadingEvents } = useEvents({
    eventId: currentEventId ?? 0,
    config: {
      enabled: !!currentEventId,
    },
  });

  const activeEvent = breakoutId ? events.find(e => e.eventId === breakoutId) : events.find(e => e.eventId === currentEventId);
  const activeEventName = activeEvent ? `${activeEvent.eventId} - ${activeEvent.name}` : 'Välj event';

  if (isLoadingEvents) {
    return (
      <div className="w-full h-full flex flex-col gap-4 items-center justify-center">
        <Spinner className="w-32 h-32" />
      </div>
    );
  }

  const isIphoneSafari = /iPhone/.test(navigator.userAgent) && /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) &&
                 navigator.vendor === 'Apple';

  return (
    <div className={cn('w-full', isIphoneSafari ? 'h-[calc(100lvh_-_80px)]' : 'h-[calc(100vh_-_60px)]')}>
      <Drawer>
        <DrawerTrigger className="absolute flex gap-2 items-start top-4 left-1/2 -translate-x-1/2 z-50 w-[90vw] text-white border-gray-700 border bg-white/15 rounded-sm ">
          <div className="flex items-center justify-start w-full p-2">
            <div className="flex gap-2 items-center justify-start text-md text-white min-w-0 flex-1">
              <DoorOpen className="w-5 h-5 shrink-0" />
              <span className="truncate w-full flex-1">{activeEventName}</span>
            </div>

            <ChevronsUpDown className="ml-auto w-4 h-4" />
          </div>
        </DrawerTrigger>
        <DrawerContent className=" bg-white/95 backdrop-blur-md flex flex-col items-center justify-start p-4 pt-0 pointer-events-auto">
          <Label className="text-lg">{getLabelValue('ChoosePassingEvent')}</Label>
          <Separator className="w-4/5 my-2" />
          <SubEventList events={events} />
        </DrawerContent>
      </Drawer>
      <div className="w-full h-full z-0">
        <Reader />
      </div>
    </div>
  );
}
